// Copyright (c) 2023 WiseTime. All rights reserved.

import { Observable } from "rxjs"
import * as Actions from "../actions"
import { Action } from "redux"
import { filter, tap, map } from "rxjs/operators"

export const redirectUrl = (url: string): void => {
  window.location.assign(url)
}

export const redirectToUrl = (
  redirectUrl: (url: string) => void
) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Actions.redirectToUrl.match),
      tap(action => redirectUrl(action.payload)),
      map(_ => Actions.redirectToUrlDone()),
    )

export default redirectToUrl(redirectUrl)
